import { render, staticRenderFns } from "./PhysicalExaminationNotice.vue?vue&type=template&id=0bca968f&scoped=true&"
import script from "./PhysicalExaminationNotice.vue?vue&type=script&lang=js&"
export * from "./PhysicalExaminationNotice.vue?vue&type=script&lang=js&"
import style0 from "./PhysicalExaminationNotice.vue?vue&type=style&index=0&id=0bca968f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca968f",
  null
  
)

export default component.exports